/**
 * Matcher for list
 *
 * Ported from [condition.testList@58fbbd4d2773e1b3b806ebd5191914914a4fe0de](https://github.com/optimizely/optimizely/blob/355acdd0edd085bc3c19163de55f909d2a239f8c/src/www/js/client/condition.js#L382)
 * @module
 */
var match = require('core/lib/match');

exports.fieldsNeeded = ['lists'];

/**
 *
 * @param {Object} value
 * @param {module:feature_list/sources/list_targeting~ListTargetingData} [value.lists]
 * @param {Condition} cond
 * @return {boolean}
 */
exports.match = function(value:any, cond:Condition): boolean {
  var allListValues = (value.lists || {}).values;

  if (!allListValues) {
    return false;
  }

  var listValue = allListValues[cond.name];

  // Intentionally cast false values to null; false/null mean "not in list"
  if (listValue === false) {
    listValue = null;
  }

  return match.hasMatch(cond.value, cond.match, listValue);
};
